var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNewRepeatIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 8.94737C3 11.7379 5.23858 14 8 14C10.7614 14 13 11.7379 13 8.94737C13 6.15688 10.7614 3.89474 8 3.89474L6.125 3.89474M6.125 3.89474L8 5.78947M6.125 3.89474L8 2",
    stroke: "currentColor"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgNewRepeatIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/new-repeat-icon.b31cfddf99f13707fb8f27c9616997dc.svg";